import { Component, Input, OnInit } from '@angular/core';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent implements OnInit {
  static key = 100822;
  @Input("pageKey") pageKey: any;
  @Input("item") item: any = {};

  selectedSearchByKey:any;
  serverSideSearchFilterText: any;
  userStateForServerSideSearch = "";
  searchBySelectedName: any;
  searchByKey:any = []

  constructor(private filterService: FilterService) { }

  ngOnInit(): void {
    let headerConfig = this.item.config?.['widget_header_configuration'] || [];
    headerConfig = headerConfig?.filter((flr: any) => flr.add_header == true)

    let fndData = headerConfig.find((r: any) => r.add_header && r.value == 'search_box' && r.server_side_search_box);
    if (fndData?.searchByKey) {
      this.searchByKey = fndData?.searchByKey || [];
      this.selectedSearchByKey = this.searchByKey[0]?.value;
    } else {
      this.searchByKey = [];
    }
    this.findSearchBySelectedName(this.selectedSearchByKey);
    
  }

  findSearchBySelectedName(key: any, hdr?: any) {
    this.searchByKey = this.searchByKey.filter((o: any) => o.value !== 'PH');

    this.searchBySelectedName = this.searchByKey.find((f: any) => f.value == key);
  }

  serverSideSearch() {
    
    if (this.userStateForServerSideSearch == this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText) return;
    this.userStateForServerSideSearch = this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText;

    let data = this.searchByKey.find((f: any) => this.selectedSearchByKey == f.value);
    if (data) {
      let selectObj = {
        filterValue: this.serverSideSearchFilterText,
        obj: {
          [data.param]:
            (data.value == 'PI' || data.value == 'HPI' || data.value == 'SPI' || data.comma)
              ? this.serverSideSearchFilterText
                ? data.value == 'PRN'
                  ? this.serverSideSearchFilterText.split(/[|@#&]+/).join(',') // excludes space
                  : this.serverSideSearchFilterText.split(/[\|\s@#&]+/).join(',') // includes space
                : ''
              : this.serverSideSearchFilterText,
          "search_prm": data.value,
        }
      }

      this.refreshData(selectObj);
      
    }

  }

  refreshData(selectObj:any) {
      let filterValue = selectObj?.filterValue
      let filterSearchParams =  filterValue ? (selectObj?.obj || '') : '';

      let fnd = this.searchByKey.find((f:any) => f.value == selectObj?.obj?.search_prm);

      // let searchDynamicParams = {
      //   search_column_name: fnd?.param || undefined,
      //   search_column_value: filterValue || undefined,
      //   search_data_type: fnd?.datatype || undefined
      // }

      this.filterService.baseQuery = Object.assign(this.filterService.baseQuery, filterSearchParams);
      this.filterService.filterQuery.next(this.filterService.baseQuery)
  }

  serverSideSearchClose(event: any) {
    if (this.serverSideSearchFilterText == "") {
      this.userStateForServerSideSearch = this.selectedSearchByKey + ' ' + this.serverSideSearchFilterText;
      let selectObj = {
        filterValue: "",
        obj: {},
      }
      setTimeout(() => {
        this.refreshData(selectObj);
      }, 100);
    }
  }
}
